import GameOverReason from '../../store/game/gameOverReason'

export default function getGameOverReasonText(reason: GameOverReason): string {
    return reason === GameOverReason.EARLY
        ? 'Рано переворачиваешь'
        : reason === GameOverReason.LATE
            ? 'Шашлык сгорел'
            : 'Насаживай мясо, а не крыс'
}
